import md5 from 'md5';

export const isNoscriptVideoBlocked = (videoUrl = '') => {
  return new Promise<boolean>((resolve, reject) => {
    const videoId = md5(videoUrl).replace(/^\d/, 'rndm');
    const { origin = '' } = new URL(videoUrl);

    // If it was blocked then break the execution.
    if (window.blockedVideoDomains?.includes(origin)) {
      resolve(true);
      return;
    }
    ((d) => {
      const container = d.createElement('div');
      const video = d.createElement('video');

      container.id = videoId;
      video.onload = (r) => {
        d?.querySelector(`#${videoId}`)?.remove();

        resolve(false);
      };
      video.onerror = (e) => {
        d?.querySelector(`#${videoId}`)?.remove();
        if (!window.blockedVideoDomains?.includes(origin)) window.blockedVideoDomains?.push(origin);

        resolve(true);
      };

      video.src = videoUrl;
      container?.appendChild(video);
      d?.querySelector('body')?.appendChild(container);

      setTimeout(() => {
        d?.querySelector(`#${videoId}`)?.remove();

        resolve(false);
      }, 1000);
    })(window.document);
  });
};
